module.exports = __webpack_public_path__ + "static/media/discover_tab_img.ff90e5e5.jpg";